module.exports = __webpack_public_path__ + "static/media/calendarImage.a2626968.jpeg";